import {useQuery} from '@tanstack/react-query'
import axios from 'axios'

export const useOnlineItemOrderData = () => {
  const dataUrl = 'http://localhost:3005/orderItems'
  const columnUrl = 'http://localhost:3006/columns'

  const rowQuery = useQuery({
    queryKey: ['onlineItemRowData', dataUrl],
    queryFn: async () => {
      const {data} = await axios.get(dataUrl)
      return data
    },
  })

  const colQuery = useQuery({
    queryKey: ['onlineItemColConfig', columnUrl],
    queryFn: async () => {
      const {data} = await axios.get(columnUrl)
      return data
    },
  })

  return {
    rowData: rowQuery.data,
    colConfig: colQuery.data,
    isLoading: rowQuery.isLoading || colQuery.isLoading,
    isError: rowQuery.isError || colQuery.isError,
  }
}
